import { defineMessages } from 'react-intl';

export default defineMessages({
    group: {
        id: 'app.components.ClassroomGroupList.group',
        defaultMessage: 'GROUP'
    },
    courses: {
        id: 'app.components.ClassroomGroupList.courses',
        defaultMessage: 'COURSES'
    },
    activities: {
        id: 'app.components.ClassroomGroupList.activities',
        defaultMessage: 'ACTIVITIES'
    },
    newCourses: {
        id: 'app.components.ClassroomGroupList.newCourses',
        defaultMessage: 'NEW COURSES'
    },
    students: {
        id: 'app.components.ClassroomGroupList.students',
        defaultMessage: 'STUDENTS'
    },
    downloadCards: {
        id: 'app.components.ClassroomGroupList.downloadCards',
        defaultMessage: 'Download sign-in cards'
    },
    downloading: {
        id: 'app.components.ClassroomGroupList.downloading',
        defaultMessage: 'downloading'
    },
    createGroup: {
        id: 'app.components.ClassroomGroupList.createGroup',
        defaultMessage: 'Create group'
    },
    skillQuests: {
        id: 'app.components.ClassroomGroupList.skillQuests',
        defaultMessage: 'SKILL QUESTS'
    },
    optedOut: {
        id: 'app.components.ClassroomGroupList.optedOut',
        defaultMessage: 'Opted out'
    },
    noVoluntaryCourseSet: {
        id: 'app.components.ClassroomGroupList.noVoluntaryCourseSet',
        defaultMessage: 'No voluntary course set'
    },
    noCourseAssigned: {
        id: 'app.components.ClassroomGroupList.noCourseAssigned',
        defaultMessage: 'No course assigned'
    }
});



// WEBPACK FOOTER //
// ./app/components/classroom-group-list/messages.js